'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(s, o) {
    if (null == s) return {};
    var l, n, t = _object_without_properties_loose(s, o);
    if (Object.getOwnPropertySymbols) {
        var e = Object.getOwnPropertySymbols(s);
        for(n = 0; n < e.length; n++)l = e[n], !(o.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(s, l) && (t[l] = s[l]);
    }
    return t;
}
function _object_without_properties_loose(s, o) {
    if (null == s) return {};
    var l, n, t = {}, e = Object.keys(s);
    for(n = 0; n < e.length; n++)l = e[n], o.indexOf(l) >= 0 || (t[l] = s[l]);
    return t;
}
const Column = renderWithRef('Column', null, (l, n)=>{
    var { children: t, span: e, spanXs: p, spanSm: u, spanMd: i, spanLg: r, spanXl: a, offset: c, offsetSm: h, offsetMd: f, offsetLg: d, offsetXl: w, push: m, pushSm: v, pushMd: $, pushLg: g, pushXl: x, pull: _, pullSm: y, pullMd: b, pullLg: j, pullXl: O, flexColumn: C = false, verticallyCenterContent: S = false, sticky: k = false, unsticky: X = 'none', floatingContainer: L = false, floatingContainerAlignment: M = 'left' } = l, P = _object_without_properties(l, [
        "children",
        "span",
        "spanXs",
        "spanSm",
        "spanMd",
        "spanLg",
        "spanXl",
        "offset",
        "offsetSm",
        "offsetMd",
        "offsetLg",
        "offsetXl",
        "push",
        "pushSm",
        "pushMd",
        "pushLg",
        "pushXl",
        "pull",
        "pullSm",
        "pullMd",
        "pullLg",
        "pullXl",
        "flexColumn",
        "verticallyCenterContent",
        "sticky",
        "unsticky",
        "floatingContainer",
        "floatingContainerAlignment"
    ]);
    let A = [
        `swan-col-${e}`
    ];
    return void 0 !== p && A.push(`swan-col-xs-${p}`), void 0 !== u && A.push(`swan-col-sm-${u}`), void 0 !== i && A.push(`swan-col-md-${i}`), void 0 !== r && A.push(`swan-col-lg-${r}`), void 0 !== a && A.push(`swan-col-xl-${a}`), void 0 !== c && A.push(`swan-col-offset-${c}`), void 0 !== h && A.push(`swan-col-sm-offset-${h}`), void 0 !== f && A.push(`swan-col-md-offset-${f}`), void 0 !== d && A.push(`swan-col-lg-offset-${d}`), void 0 !== w && A.push(`swan-col-xl-offset-${w}`), void 0 !== _ && A.push(`swan-col-pull-${_}`), void 0 !== y && A.push(`swan-col-sm-pull-${y}`), void 0 !== b && A.push(`swan-col-md-pull-${b}`), void 0 !== j && A.push(`swan-col-lg-pull-${j}`), void 0 !== O && A.push(`swan-col-xl-pull-${O}`), void 0 !== m && A.push(`swan-col-push-${m}`), void 0 !== v && A.push(`swan-col-sm-push-${v}`), void 0 !== $ && A.push(`swan-col-md-push-${$}`), void 0 !== g && A.push(`swan-col-lg-push-${g}`), void 0 !== x && A.push(`swan-col-xl-push-${x}`), C && A.push('swan-col-flex-column'), S && A.push('swan-col-vertically-center'), k && A.push('swan-col-sticky'), 'xs' === X && A.push('swan-col-unsticky-xs'), L && A.push('swan-floating-container'), 'right' === M && A.push('swan-floating-container-right'), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        props: P,
        classNames: A,
        children: t
    });
});

export { Column };
